import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Production from '../components/Production';
import Catalog from '../components/Catalog';
import Products from '../components/Products';
import Industries from '../components/Industries';
import Gallery from '../components/Gallery';
import Supply from '../components/Supply';
import Directions from '../components/Directions';
import ContactForm from '../components/ContactForm';
import Contacts from '../components/Contacts';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const element = document.querySelector(location.hash);
    if (!element) return;
    const headerHeight = document.querySelector('.header')?.offsetHeight || 0;
    const top = element.getBoundingClientRect().top + window.scrollY - headerHeight;
    window.scrollTo({ top, behavior: 'smooth' });
  }, [location]);

  return (
    <>
      <Header />
      <Hero />
      <Production />
      <Catalog />
      <Products />
      <Industries />
      <Gallery />
      <Directions />
      <Supply />
      <ContactForm />
      <Contacts />
    </>
  );
};

export default Home;
